/* NERIVA5 compatibility with Releasit's automatic-discount guard.
 * Shopify remains authoritative: never invent an amount or accept an invalid code.
 * Other codes retain Releasit's implementation. No order is submitted here.
 */
(function () {
  'use strict';
  var CODE = 'NERIVA5', END = Date.parse('2026-10-11T22:59:59Z');
  if (location.hostname !== 'neriva.pt' || window.__neriva5Compat) return;
  window.__neriva5Compat = true;
  var installed = false, pending = false, attempts = 0;
  var query = 'mutation ApplyNeriva5($id:ID!,$codes:[String!]!,$country:CountryCode) @inContext(country:$country){cartDiscountCodesUpdate(cartId:$id,discountCodes:$codes){cart{id discountCodes{code applicable} discountAllocations{__typename discountedAmount{amount currencyCode} ... on CartCodeDiscountAllocation{code}} lines(first:250){nodes{id quantity merchandise{... on ProductVariant{id}} discountAllocations{__typename discountedAmount{amount currencyCode} ... on CartCodeDiscountAllocation{code}}} pageInfo{hasNextPage}}} userErrors{field message}}}';
  function cartSignature(cart) {
    return cart.token + '|' + (cart.items || []).map(function (item) {
      return String(item.variant_id || item.id) + ':' + item.quantity;
    }).sort().join('|');
  }
  function cents(amount) {
    if (!/^\d+(?:\.\d{1,2})?$/.test(String(amount))) return NaN;
    var parts = String(amount).split('.');
    return Number(parts[0]) * 100 + Number((parts[1] || '').padEnd(2, '0'));
  }
  function allocation(cart) {
    if (!cart || cart.lines?.pageInfo?.hasNextPage !== false ||
        !cart.discountCodes?.some(function (c) { return c.code.toUpperCase() === CODE && c.applicable; })) return null;
    var select = function (list) { return (list || []).filter(function (a) {
      return a.__typename === 'CartCodeDiscountAllocation' && a.code?.toUpperCase() === CODE;
    }); };
    var root = select(cart.discountAllocations);
    var selected = root.length ? root : (cart.lines.nodes || []).flatMap(function (l) { return select(l.discountAllocations); });
    if (!selected.length || selected.some(function (a) { return a.discountedAmount?.currencyCode !== 'EUR'; })) return null;
    var total = selected.reduce(function (sum, a) { return sum + cents(a.discountedAmount.amount); }, 0);
    return Number.isInteger(total) && total > 0 && total <= 500 ? total : null;
  }
  function sameLines(responseCart, localCart) {
    var expected = new Map();
    (localCart.items || []).forEach(function (item) {
      var id = String(item.variant_id || item.id);
      expected.set(id, (expected.get(id) || 0) + Number(item.quantity));
    });
    var actual = new Map();
    (responseCart.lines.nodes || []).forEach(function (line) {
      var id = String(line.merchandise?.id || '').split('/').pop();
      actual.set(id, (actual.get(id) || 0) + Number(line.quantity));
    });
    return expected.size > 0 && expected.size === actual.size &&
      Array.from(expected).every(function (entry) { return actual.get(entry[0]) === entry[1]; });
  }
  function install() {
    var rsi = window._rsi, discounts = rsi?.form?.discounts;
    if (!discounts || typeof discounts.parseCheckout !== 'function' ||
        typeof discounts.onParsedCheckout !== 'function' || typeof discounts.getLimitToOneCodeDiscounts !== 'function') return false;
    var originalParse = discounts.parseCheckout;
    var originalLimit = discounts.getLimitToOneCodeDiscounts;
    discounts.getLimitToOneCodeDiscounts = function () {
      if (discounts.codesApplied.some(function (d) { return d.text.toUpperCase() === CODE; })) {
        return discounts.codesApplied.filter(function (d) {
          return d.text.toUpperCase() === CODE || d.text === discounts.automatic.defaultCodeText || d.text === rsi.upsells.defaultCodeText;
        });
      }
      return originalLimit.apply(this, arguments);
    };
    discounts.parseCheckout = async function (code) {
      if (String(code).toUpperCase() !== CODE) return originalParse.apply(this, arguments);
      if (pending) return;
      pending = true;
      var signature = cartSignature(rsi.cart);
      function fail() {
        discounts.codesApplied = discounts.codesApplied.filter(function (d) { return d.text.toUpperCase() !== CODE; });
        discounts.updateTotalAmount();
        discounts.onParsedCheckout(false);
      }
      try {
        if (Date.now() > END || !rsi.cart.token || rsi.form.quantityOffers.selectedOfferIn) return fail();
        var featureNode = document.getElementById('shopify-features');
        var features = JSON.parse(featureNode?.textContent || '{}');
        if (!['neriva.pt', 'wze4bp-3r.myshopify.com'].includes(features.domain) || !features.accessToken) return fail();
        var response = await fetch('https://' + features.domain + '/api/2026-04/graphql.json', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': features.accessToken },
          body: JSON.stringify({ query: query, variables: { id: 'gid://shopify/Cart/' + rsi.cart.token, codes: [CODE], country: 'PT' } }),
          signal: AbortSignal.timeout(12000),
        });
        var result = await response.json();
        var payload = result.data?.cartDiscountCodesUpdate;
        var amount = allocation(payload?.cart);
        if (!response.ok || result.errors?.length || payload?.userErrors?.length || amount === null ||
            Date.now() > END || signature !== cartSignature(rsi.cart) || !sameLines(payload.cart, rsi.cart)) return fail();
        discounts.codesApplied = discounts.codesApplied.filter(function (d) { return d.text.toUpperCase() !== CODE; });
        // Preserve Releasit's automatic pack discount and its native order data.
        discounts.onParsedCheckout({ type: 'fixed_amount', amount: amount }, CODE);
      } catch (_) { fail(); } finally { pending = false; }
    };
    document.addEventListener('click', function (event) {
      var button = event.target.closest?.('#_rsi-modal-discounts-form-apply');
      var input = document.getElementById('_rsi-modal-discounts-form-code');
      if (!button || input?.value.trim().toUpperCase() !== CODE) return;
      event.preventDefault(); event.stopImmediatePropagation();
      discounts.removeDiscountErrors(); discounts.isLoading = true;
      discounts.parseCheckout(CODE);
    }, true);
    var previousSubmit = window._COD_FORM_OVERWRITE_ON_SUBMIT_START;
    window._COD_FORM_OVERWRITE_ON_SUBMIT_START = function (data) {
      if (pending) return false;
      if (discounts.codesApplied.some(function (d) { return d.text.toUpperCase() === CODE; }) && Date.now() > END) {
          discounts.codesApplied = discounts.codesApplied.filter(function (d) { return d.text.toUpperCase() !== CODE; });
          discounts.updateTotalAmount(); discounts.setDiscountError();
        return false;
      }
      return typeof previousSubmit === 'function' ? previousSubmit.apply(this, arguments) : true;
    };
    return true;
  }
  var timer = setInterval(function () {
    if (!installed) installed = install();
    if (installed || ++attempts >= 600) clearInterval(timer);
  }, 100);
})();
